import React from 'react'
import { css } from '@emotion/react'
import externalLink from '../images/svgs/external-link-white.svg'

const externalLinkEmphasisStyle = theme => css({
    fontFamily: theme.fonts.secondary,
    fontWeight: 700,
})

const externalLinkStyle = {
    textTransform: 'capitalize',
    display: 'flex',
    gap: 8,
}

export default function NavAccount() {
    return <div css={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridTemplateRows: '2',
        gap: 24,
        width: '100%',
    }}>
        <a href='https://profile.inmusicbrands.com/' target='_blank' rel='noreferrer' css={[externalLinkStyle, externalLinkEmphasisStyle, { 
            gridRow: 1, 
            gridColumn: '1/2',
            '@media(max-width: 1024px)': {
                gridColumn: '1/5',
            }
        }]}>
            inMusic Account
            <img src={externalLink} alt='external link' />
        </a>
        <a href='https://profile.inmusicbrands.com/customer/account/login/' target='_blank' rel='noreferrer' css={[externalLinkStyle, { 
            gridRow: 2,
            gridColumn: '1/2',
            '@media(max-width: 1024px)': {
                gridColumn: '1/3',
            }
        }]}>
            Sign In
            <img src={externalLink} alt='external link' />
        </a>
        <a href='https://profile.inmusicbrands.com/customer/account/create/' target='_blank' rel='noreferrer' css={[externalLinkStyle, {
            gridRow: 2,
            gridColumn: '2/3',
            '@media(max-width: 1024px)': {
                gridColumn: '3/5',
            }
        }]}>
            Register
            <img src={externalLink} alt='external link' />
        </a>
    </div>
}
